import { ROUTE_PATH } from '@core/constants';
import { Utils } from '@core/helper/utils.helper';
import { SESSION_STORAGE_KEY } from './local-storage-key.config';

export const CONFIG_LOG = {
    IS_DEBUG: (location.hostname === "localhost" || location.hostname === "127.0.0.1") ? true : false,
    IS_SHOW_LOCAL_LOG: false,
    TIMEOUT_CALL_SAUCER_LOG: 30000,
    MAX_COUNT_TO_CALL_SAUCER_LOG: 50,
    API_GET_CLIENT_IP: 'https://ipinfo.io/json'
}

export const LOG_TYPE = {
    LOG_ACTION: 1,
    LOG_ERROR: 2,
    LOG_SYSTEM: 3
};

export const ACTION_LOG = {
    LOGIN: "Login",                                                     // ログインする
    LOGOUT: "Logout",                                                   // ログアウトする
    ACCESS: "ChangeScreen",                                             // Access（サイト外へのアクセス）
    VIEW: "View",                                                       // 閲覧
    CREATE: "Create",                                                   // 新規
    UPDATE: "Update",                                                   // 更新
    DELETE: "Delete",                                                   // 削除
    SEARCH: "Search",                                                   // 検索
    CHANGE_FILTER: "ChangeFilter",                                      // フィルター変更
    SORT: "Sort", 
    CHANGE_PAGE: "Pagination",                                          // ページ送り
    CHANGE_TAB: "ChangeTab",                                            // タブ切り替え
    SHOW_DIALOG: "ShowDialog",                                          // ダイアログ表示
    SHOW_CALENDAR: "ShowCalendar",                                      // カレンダー表示
    CLOSE_DIALOG: "CloseDialog",                                        // ダイアログを閉じる
    DOWNLOAD_FILE: "DownloadFile",                                      // ファイルダウンロード 
    POST: "POST",     
    GET: "GET",      
    PUT: "PUT",
    ACTION_ERROR: "アクションエラー",
    CHANGE_VIEW_TYPE: "ChangeViewType",
    LOCK_PAGE: "Rock"                                                    // 画面ロック
};

export const CONTENT_LOG = {
    LOGOUT: "ログアウトする",
    CHANGE_BATHROOM: '浴室切替',
    CHANGE_DATE: '日付切替',
    TODAY: '本日',
    CHOOSE_FROM_OTHER_ROOM: '他の浴室の利用者から選ぶ',
    REMOVE_FROM_LIST: '入浴リストから外す',
    SAVE_USER_INFO: '利用者情報を保存',
    SAVE: '保存',
    VIEW: '閲覧',
    DARK_MODE: 'ダークモード',
    FULL_SCREEN: 'フルスクリーン',
    SYNC: '手動更新',
    CHANGE_PAGE: 'ページ送り',
    LOCK_PAGE: '画面ロック',
    SETTING: '設定',
    HANDOVER: '申し送り',
    CARE_PLAN: 'ケアプラン',
    CHANGE_WEEK: '週切替',
    UPDATE_FROM_SCHEDULE: 'スケジュールから更新'
};


export const SCREEN_NAME = {
    COMMON: '',
    HOME: 'ホーム',
    LOGIN: 'ログイン',
    LOGOUT: 'ログアウト',
    STAFF_INFO: 'システム設定 ＞ 職員情報',
    SYNC_CK_MASTER: 'システム設定 ＞ CKマスタ同期',
    SETTING_DIALOG: '設定',
    CHECK_SHEET_NYUSHO: '入所チェックシート',
    CHECK_SHEET_TSUSHO: '通所チェックシート',
    CHECK_SHEET_SHORT_TIME: 'チェックシート（短時間型対応版）',
    CHECK_SHEET_FUNCTIONAL_TRAINING: 'チェックシート（機能訓練排泄対応版）',
    USER_INFO_SHEET: '利用者情報シート',
    EXCRETION_CHECK_SHEET: '排泄チェックシート',
    BATH_CHECK_SHEET_NYUSHO: '入浴チェックシート（入所）',
    BATH_CHECK_SHEET_TSUSHO: '入浴チェックシート（通所）',
    BATH_SCHEDULE_ADMISSION: '入浴予定管理（入所）',
    BATH_SCHEDULE_WEEKLY_ADJUST: '週間予定から調整する',
    BATH_SCHEDULE_COMMUTE: '入浴予定管理（通所）',
    TITLE_LINK_SETTING: 'タイトル連携設定',
    TITLE_LINK_SETTING_DIALOG: 'タイトル連携設定ダイアログ',
    TITLE_LINK_DISPLAY_ANSWER_SETTING: '表示回答項目設定',
    BATH_ROOM_INFO: '浴室情報',
    BATH_ROOM_INFO_ADD: '浴室情報 ＞ 追加',
    BATH_ROOM_INFO_EDIT: '浴室情報 ＞ 編集',
    BATH_ROOM_USER_SELECT_DIALOG: '利用者選択ダイアログ',
    USER_INFO: '利用者情報',
    USER_INFO_DIALOG: '利用者ダイアログ',
};

export const SAUCER_LOG_ACTION = {
    COMMON_CALL_API: {
        GET: {screenName: SCREEN_NAME.COMMON, action: ACTION_LOG.GET, body: ''},
        POST: {screenName: SCREEN_NAME.COMMON, action: ACTION_LOG.POST, body: ''},
        PUT: {screenName: SCREEN_NAME.COMMON, action: ACTION_LOG.PUT, body: ''},
    },
    //#region ホーム
    // ホーム
    HOME: {
        VIEW: {screenName: SCREEN_NAME.HOME, action: ACTION_LOG.VIEW, body: ''},
    },
    //#endregion
    // ログイン
    LOGIN: {
        ACTION_LOGIN: {screenName: SCREEN_NAME.LOGIN, action: ACTION_LOG.LOGIN, body: 'ログイン成功'},
        SUCCESS: {screenName: SCREEN_NAME.LOGIN, action: ACTION_LOG.POST, body: 'ログイン成功'},
        FAILED: {screenName: SCREEN_NAME.LOGIN, action: ACTION_LOG.LOGIN, body: 'ログイン失敗'}
    },
    // ヘッダ
    LOGOUT: {
        SUCCESS: {screenName: SCREEN_NAME.LOGOUT, action: ACTION_LOG.LOGOUT, body: 'ログアウト成功'},
        FAILED: {screenName: SCREEN_NAME.LOGOUT, action: ACTION_LOG.LOGOUT, body: 'ログアウト失敗'}
    },
    //#region ヘッダ
    // 案内
    // CKマスタ同期
    SYNC_CK_MASTER: {
        VIEW: {screenName: SCREEN_NAME.SYNC_CK_MASTER, action: ACTION_LOG.VIEW, body: ''},
        SYNC: {screenName: SCREEN_NAME.SYNC_CK_MASTER, action: ACTION_LOG.CREATE, body: ''},
        DELETE_SYNC: {screenName: SCREEN_NAME.SYNC_CK_MASTER, action: ACTION_LOG.DELETE, body: ''},
    },
    //#endregion
    //#region 設定ダイアログ
    SETTING: {
        VIEW: {screenName: SCREEN_NAME.SETTING_DIALOG, action: ACTION_LOG.VIEW, body: ''},
        CHANGE_TAB: {screenName: SCREEN_NAME.SETTING_DIALOG, action: ACTION_LOG.CHANGE_TAB, body: ''},
        CLOSE_DIALOG: {screenName: SCREEN_NAME.SETTING_DIALOG, action: ACTION_LOG.CLOSE_DIALOG, body: ''},
        UPDATE: {screenName: SCREEN_NAME.SETTING_DIALOG, action: ACTION_LOG.UPDATE, body: ''},
    },
    //#endregion
    //#region 入所チェックシート
    CHECK_SHEET_NYUSHO: {
        VIEW: {screenName: SCREEN_NAME.CHECK_SHEET_NYUSHO, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.CHECK_SHEET_NYUSHO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.CHECK_SHEET_NYUSHO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.CHECK_SHEET_NYUSHO, action: ACTION_LOG.UPDATE, body: ''},
        CHANGE_PAGE: {screenName: SCREEN_NAME.CHECK_SHEET_NYUSHO, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        LOCK_PAGE: {screenName: SCREEN_NAME.CHECK_SHEET_NYUSHO, action: ACTION_LOG.LOCK_PAGE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.CHECK_SHEET_NYUSHO, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    //#endregion
    //#region 通所チェックシート
    CHECK_SHEET_TSUSHO: {
        VIEW: {screenName: SCREEN_NAME.CHECK_SHEET_TSUSHO, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.CHECK_SHEET_TSUSHO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.CHECK_SHEET_TSUSHO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.CHECK_SHEET_TSUSHO, action: ACTION_LOG.UPDATE, body: ''},
        CHANGE_PAGE: {screenName: SCREEN_NAME.CHECK_SHEET_TSUSHO, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        LOCK_PAGE: {screenName: SCREEN_NAME.CHECK_SHEET_TSUSHO, action: ACTION_LOG.LOCK_PAGE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.CHECK_SHEET_TSUSHO, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    //#endregion
    //#region チェックシート（短時間型対応版）
    CHECK_SHEET_SHORT_TIME: {
        VIEW: {screenName: SCREEN_NAME.CHECK_SHEET_SHORT_TIME, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.CHECK_SHEET_SHORT_TIME, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.CHECK_SHEET_SHORT_TIME, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.CHECK_SHEET_SHORT_TIME, action: ACTION_LOG.UPDATE, body: ''},
        CHANGE_PAGE: {screenName: SCREEN_NAME.CHECK_SHEET_SHORT_TIME, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        LOCK_PAGE: {screenName: SCREEN_NAME.CHECK_SHEET_SHORT_TIME, action: ACTION_LOG.LOCK_PAGE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.CHECK_SHEET_SHORT_TIME, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    //#endregion
    //#region チェックシート（機能訓練排泄対応版）
    CHECK_SHEET_FUNCTIONAL_TRAINING: {
        VIEW: {screenName: SCREEN_NAME.CHECK_SHEET_FUNCTIONAL_TRAINING, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.CHECK_SHEET_FUNCTIONAL_TRAINING, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.CHECK_SHEET_FUNCTIONAL_TRAINING, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.CHECK_SHEET_FUNCTIONAL_TRAINING, action: ACTION_LOG.UPDATE, body: ''},
        CHANGE_PAGE: {screenName: SCREEN_NAME.CHECK_SHEET_FUNCTIONAL_TRAINING, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        LOCK_PAGE: {screenName: SCREEN_NAME.CHECK_SHEET_FUNCTIONAL_TRAINING, action: ACTION_LOG.LOCK_PAGE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.CHECK_SHEET_FUNCTIONAL_TRAINING, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    //#endregion
    //#region 利用者情報シート
    USER_INFO_SHEET: {
        VIEW: {screenName: SCREEN_NAME.USER_INFO_SHEET, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.USER_INFO_SHEET, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.USER_INFO_SHEET, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.USER_INFO_SHEET, action: ACTION_LOG.UPDATE, body: ''},
        CHANGE_PAGE_HANDOVER: {screenName: `${SCREEN_NAME.USER_INFO_SHEET} ＞ ${CONTENT_LOG.HANDOVER}`, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        CHANGE_PAGE_CARE_PLAN: {screenName: `${SCREEN_NAME.USER_INFO_SHEET} ＞ ${CONTENT_LOG.CARE_PLAN}`, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.USER_INFO_SHEET, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    //#endregion
    //#region 排泄チェックシート
    EXCRETION_CHECK_SHEET: {
        VIEW: {screenName: SCREEN_NAME.EXCRETION_CHECK_SHEET, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.EXCRETION_CHECK_SHEET, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.EXCRETION_CHECK_SHEET, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.EXCRETION_CHECK_SHEET, action: ACTION_LOG.UPDATE, body: ''},
        CHANGE_PAGE: {screenName: SCREEN_NAME.EXCRETION_CHECK_SHEET, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        LOCK_PAGE: {screenName: SCREEN_NAME.EXCRETION_CHECK_SHEET, action: ACTION_LOG.LOCK_PAGE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.EXCRETION_CHECK_SHEET, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    //#endregion
    //#region 入浴チェックシート
    BATH_CHECK_SHEET_NYUSHO: {
        VIEW: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_NYUSHO, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_NYUSHO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_NYUSHO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_NYUSHO, action: ACTION_LOG.UPDATE, body: ''},
        CHANGE_PAGE: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_NYUSHO, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        LOCK_PAGE: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_NYUSHO, action: ACTION_LOG.LOCK_PAGE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_NYUSHO, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    BATH_CHECK_SHEET_TSUSHO: {
        VIEW: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_TSUSHO, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_TSUSHO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_TSUSHO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_TSUSHO, action: ACTION_LOG.UPDATE, body: ''},
        CHANGE_PAGE: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_TSUSHO, action: ACTION_LOG.CHANGE_PAGE, body: ''},
        LOCK_PAGE: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_TSUSHO, action: ACTION_LOG.LOCK_PAGE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.BATH_CHECK_SHEET_TSUSHO, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    //#endregion
    //#region 入浴予定管理（入所）
    BATH_SCHEDULE_ADMISSION: {
        VIEW: {screenName: SCREEN_NAME.BATH_SCHEDULE_ADMISSION, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.BATH_SCHEDULE_ADMISSION, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.BATH_SCHEDULE_ADMISSION, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        CHANGE_BATHROOM: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.CHANGE_BATHROOM}`, action: ACTION_LOG.VIEW, body: ''},
        CHANGE_DATE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.CHANGE_DATE}`, action: ACTION_LOG.VIEW, body: ''},
        TODAY: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.TODAY}`, action: ACTION_LOG.VIEW, body: ''},
        CHOOSE_FROM_OTHER_ROOM: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.CHOOSE_FROM_OTHER_ROOM}`, action: ACTION_LOG.VIEW, body: ''},
        REMOVE_FROM_LIST: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.REMOVE_FROM_LIST}`, action: ACTION_LOG.VIEW, body: ''},
        SAVE_USER_INFO: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.SAVE_USER_INFO}`, action: ACTION_LOG.UPDATE, body: ''},
        CREATE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.CREATE, body: ''},
        UPDATE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.UPDATE, body: ''},
        DELETE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_ADMISSION} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.DELETE, body: ''},
    },
    //#endregion
    //#region 週間予定から調整する
    BATH_SCHEDULE_WEEKLY_ADJUST: {
        VIEW: {screenName: SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        CHANGE_BATHROOM: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST} ＞ ${CONTENT_LOG.CHANGE_BATHROOM}`, action: ACTION_LOG.VIEW, body: ''},
        CHANGE_WEEK: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST} ＞ ${CONTENT_LOG.CHANGE_WEEK}`, action: ACTION_LOG.VIEW, body: ''},
        CHANGE_TAB: {screenName: SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST, action: ACTION_LOG.CHANGE_TAB, body: ''},
        CREATE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.CREATE, body: ''},
        UPDATE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.UPDATE, body: ''},
        DELETE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_WEEKLY_ADJUST} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.DELETE, body: ''},
    },
    //#endregion
    //#region 入浴予定管理（通所）
    BATH_SCHEDULE_COMMUTE: {
        VIEW: {screenName: SCREEN_NAME.BATH_SCHEDULE_COMMUTE, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.BATH_SCHEDULE_COMMUTE, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        FULL_SCREEN: {screenName: SCREEN_NAME.BATH_SCHEDULE_COMMUTE, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        CHANGE_BATHROOM: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.CHANGE_BATHROOM}`, action: ACTION_LOG.VIEW, body: ''},
        CHANGE_DATE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.CHANGE_DATE}`, action: ACTION_LOG.VIEW, body: ''},
        TODAY: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.TODAY}`, action: ACTION_LOG.VIEW, body: ''},
        CHOOSE_FROM_OTHER_ROOM: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.CHOOSE_FROM_OTHER_ROOM}`, action: ACTION_LOG.VIEW, body: ''},
        SYNC_FROM_SCHEDULE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.UPDATE_FROM_SCHEDULE}`, action: ACTION_LOG.VIEW, body: ''},
        REMOVE_FROM_LIST: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.REMOVE_FROM_LIST}`, action: ACTION_LOG.VIEW, body: ''},
        SAVE_USER_INFO: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.SAVE_USER_INFO}`, action: ACTION_LOG.UPDATE, body: ''},
        CREATE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.CREATE, body: ''},
        UPDATE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.UPDATE, body: ''},
        DELETE: {screenName: `${SCREEN_NAME.BATH_SCHEDULE_COMMUTE} ＞ ${CONTENT_LOG.SAVE}`, action: ACTION_LOG.DELETE, body: ''},
    },
    //#endregion
    //#region タイトル連携設定
    TITLE_LINK_SETTING: {
        VIEW: {screenName: SCREEN_NAME.TITLE_LINK_SETTING, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.TITLE_LINK_SETTING, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        CREATE: {screenName: SCREEN_NAME.TITLE_LINK_SETTING, action: ACTION_LOG.CREATE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.TITLE_LINK_SETTING, action: ACTION_LOG.UPDATE, body: ''},
        DELETE: {screenName: SCREEN_NAME.TITLE_LINK_SETTING, action: ACTION_LOG.DELETE, body: ''},
        CHANGE_TAB: {screenName: SCREEN_NAME.TITLE_LINK_SETTING, action: ACTION_LOG.CHANGE_TAB, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.TITLE_LINK_SETTING, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    TITLE_LINK_SETTING_DIALOG: {
        VIEW: {screenName: SCREEN_NAME.TITLE_LINK_SETTING_DIALOG, action: ACTION_LOG.VIEW, body: ''},
        CREATE: {screenName: SCREEN_NAME.TITLE_LINK_SETTING_DIALOG, action: ACTION_LOG.CREATE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.TITLE_LINK_SETTING_DIALOG, action: ACTION_LOG.UPDATE, body: ''},
        DELETE: {screenName: SCREEN_NAME.TITLE_LINK_SETTING_DIALOG, action: ACTION_LOG.DELETE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.TITLE_LINK_SETTING_DIALOG, action: ACTION_LOG.SHOW_DIALOG, body: ''},
        CLOSE_DIALOG: {screenName: SCREEN_NAME.TITLE_LINK_SETTING_DIALOG, action: ACTION_LOG.CLOSE_DIALOG, body: ''},
    },
    TITLE_LINK_DISPLAY_ANSWER_SETTING: {
        VIEW: {screenName: SCREEN_NAME.TITLE_LINK_DISPLAY_ANSWER_SETTING, action: ACTION_LOG.VIEW, body: ''},
        CLOSE_DIALOG: {screenName: SCREEN_NAME.TITLE_LINK_DISPLAY_ANSWER_SETTING, action: ACTION_LOG.CLOSE_DIALOG, body: ''},
        CREATE: {screenName: SCREEN_NAME.TITLE_LINK_DISPLAY_ANSWER_SETTING, action: ACTION_LOG.CREATE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.TITLE_LINK_DISPLAY_ANSWER_SETTING, action: ACTION_LOG.UPDATE, body: ''},
        DELETE: {screenName: SCREEN_NAME.TITLE_LINK_DISPLAY_ANSWER_SETTING, action: ACTION_LOG.DELETE, body: ''},
    },
    //#endregion
    //#region 浴室情報
    BATH_ROOM_INFO: {
        VIEW: {screenName: SCREEN_NAME.BATH_ROOM_INFO, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.BATH_ROOM_INFO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        ADD_ROOM: {screenName: SCREEN_NAME.BATH_ROOM_INFO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        EDIT_ROOM: {screenName: SCREEN_NAME.BATH_ROOM_INFO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
    },
    BATH_ROOM_INFO_ADD: {
        VIEW: {screenName: SCREEN_NAME.BATH_ROOM_INFO_ADD, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.BATH_ROOM_INFO_ADD, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.BATH_ROOM_INFO_ADD, action: ACTION_LOG.SHOW_DIALOG, body: ''},
        CREATE: {screenName: SCREEN_NAME.BATH_ROOM_INFO_ADD, action: ACTION_LOG.CREATE, body: ''},
    },
    BATH_ROOM_INFO_EDIT: {
        VIEW: {screenName: SCREEN_NAME.BATH_ROOM_INFO_EDIT, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.BATH_ROOM_INFO_EDIT, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.BATH_ROOM_INFO_EDIT, action: ACTION_LOG.SHOW_DIALOG, body: ''},
        DELETE: {screenName: SCREEN_NAME.BATH_ROOM_INFO_EDIT, action: ACTION_LOG.DELETE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.BATH_ROOM_INFO_EDIT, action: ACTION_LOG.UPDATE, body: ''},
    },
    BATH_ROOM_USER_SELECT_DIALOG: {
        VIEW: {screenName: SCREEN_NAME.BATH_ROOM_USER_SELECT_DIALOG, action: ACTION_LOG.VIEW, body: ''},
        CHANGE_TAB: {screenName: SCREEN_NAME.BATH_ROOM_USER_SELECT_DIALOG, action: ACTION_LOG.CHANGE_TAB, body: ''},
        CLOSE_DIALOG: {screenName: SCREEN_NAME.BATH_ROOM_USER_SELECT_DIALOG, action: ACTION_LOG.CLOSE_DIALOG, body: ''},
    },
    //#endregion
    //#region 利用者情報
    USER_INFO: {
        VIEW: {screenName: SCREEN_NAME.USER_INFO, action: ACTION_LOG.VIEW, body: ''},
        DARK_MODE: {screenName: SCREEN_NAME.USER_INFO, action: ACTION_LOG.CHANGE_VIEW_TYPE, body: ''},
        CHANGE_TAB: {screenName: SCREEN_NAME.USER_INFO, action: ACTION_LOG.CHANGE_TAB, body: ''},
        SHOW_DIALOG: {screenName: SCREEN_NAME.USER_INFO, action: ACTION_LOG.SHOW_DIALOG, body: ''},
    },
    USER_INFO_DIALOG: {
        VIEW: {screenName: SCREEN_NAME.USER_INFO_DIALOG, action: ACTION_LOG.VIEW, body: ''},
        CLOSE_DIALOG: {screenName: SCREEN_NAME.USER_INFO_DIALOG, action: ACTION_LOG.CLOSE_DIALOG, body: ''},
        CREATE: {screenName: SCREEN_NAME.USER_INFO_DIALOG, action: ACTION_LOG.CREATE, body: ''},
        UPDATE: {screenName: SCREEN_NAME.USER_INFO_DIALOG, action: ACTION_LOG.UPDATE, body: ''},
        DELETE: {screenName: SCREEN_NAME.USER_INFO_DIALOG, action: ACTION_LOG.DELETE, body: ''},
    },
    //#endregion
};

/** Map route -> SAUCER_LOG_ACTION preset group; returns null if route chưa được map. */
export function getSaucerLogActionByRoute(url: string): any {
    if (url.includes(ROUTE_PATH.CHECK_SHEET_NYUSHO)) return SAUCER_LOG_ACTION.CHECK_SHEET_NYUSHO;
    if (url.includes(ROUTE_PATH.CHECK_SHEET_TSUSHO)) return SAUCER_LOG_ACTION.CHECK_SHEET_TSUSHO;
    if (url.includes(ROUTE_PATH.CHECK_SHEET_SHORT_TIME)) return SAUCER_LOG_ACTION.CHECK_SHEET_SHORT_TIME;
    if (url.includes(ROUTE_PATH.CHECK_SHEET_FUNCTIONAL_TRAINING)) return SAUCER_LOG_ACTION.CHECK_SHEET_FUNCTIONAL_TRAINING;
    // BATHE_MANAGEMENT (入浴予定管理) phục vụ chung cho ADMISSION/COMMUTE/WEEKLY_ADJUST tuỳ state runtime
    // (không xác định được chỉ từ URL) -> màn hình tự log DARK_MODE/FULL_SCREEN trực tiếp, không qua route map này.
    if (url.includes(ROUTE_PATH.EXCRETION_MONITOR)) return SAUCER_LOG_ACTION.EXCRETION_CHECK_SHEET;
    if (url.includes(ROUTE_PATH.BATHING_SCHEDULE)) return getBathCheckSheetSaucerLogAction();
    if (url.includes(ROUTE_PATH.USER_DASHBOARD)) return SAUCER_LOG_ACTION.USER_INFO_SHEET;
    // SaucerLog [2/6]: ダークモード（ChangeViewType）
    if (url.includes(ROUTE_PATH.TITLE_SETTINGS)) return SAUCER_LOG_ACTION.TITLE_LINK_SETTING;
    return null;
}

/** Bath check sheet uses one route for nyusho/tsusho -> pick the group by selected office type. */
function getBathCheckSheetSaucerLogAction(): any {
    const officeSelected = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY.officeSelected) || 'null');
    return Utils.isNyusho(officeSelected?.officeType) ? SAUCER_LOG_ACTION.BATH_CHECK_SHEET_NYUSHO : SAUCER_LOG_ACTION.BATH_CHECK_SHEET_TSUSHO;
}
